import axios from 'axios';

export default {
  data() {
    return {
      dialogOrdered: false,
      checkbox: false,
      hash: null,
      dialogCheckSms: false,
      code: '',
      form: {
        delivery_email: this.$store.state.user.email,
        delivery_address: '',
        is_allow_cancel: false,
      },
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
    };
  },
  computed: {
    userCanMakeTransaction() {
      return this.user && this.user.can_make_transaction;
    },
    userCanMakeTransactionReason() {
      return this.user && this.user.can_make_transaction_reason;
    },
    user() {
      return this.$store.state.user;
    },
    balance() {
      return this.$store.state.user.balance * 1;
    },
    userHasPassport() {
      return this.user && this.user.account && this.user.account.status === 'approved';
    },
    loading() {
      return this.$store.state.loading;
    },
    cart() {
      return this.$store.state.eps.cart;
    },
    cartSummary() {
      return this.$store.state.eps.cartSummary;
    },
    cartLength() {
      return this.$store.state.eps.cartLength;
    },
    productsCartLength() {
      return this.$store.state.shop.cart.cartLength;
    },
    cards() {
      return this.$store.state.eps.cards;
    },
    epsSettings() { return +this.$store.state.settings.eps_sms_check; },
    validateCode() { return !!(this.hash && this.code && this.code.length === 6); },
    hasPlastic() {
      let hasPlastic = false;
      Object.keys(this.cart).forEach((cardType) => {
        for (let i = 0; i < this.cards.length; i += 1) {
          if (this.cards[i].type === cardType && this.cards[i].is_plastic) {
            hasPlastic = true;
          }
        }
      });
      return hasPlastic;
    },
  },
  mounted() {
    this.dialogOrdered = false;
    this.form.is_allow_cancel = false;
    this.form.delivery_email = this.$store.state.user.email;
    this.form.delivery_address = '';
    this.$store.dispatch('GetProfile');
    this.$store.dispatch('eps/GetCards');
  },
  methods: {
    GetCard(cardType) {
      for (let i = 0; i < this.cards.length; i += 1) {
        if (this.cards[i].type === cardType) {
          return this.cards[i];
        }
      }
      return null;
    },
    GetCardTitle(price, cardType) {
      const card = this.GetCard(cardType);
      let text = card.title;
      for (let i = 0; i < card.nominals_text.length; i += 1) {
        if (card.nominals_text[i].price === parseInt(price, 10)) {
          text = `${text} ${card.nominals_text[i].nominal}`;
        }
      }
      return text;
    },
    GetCardHint(price, cardType) {
      const card = this.GetCard(cardType);
      for (let i = 0; i < card.nominals_text.length; i += 1) {
        if (card.nominals_text[i].price === parseInt(price, 10)) {
          return `${card.nominals_text[i].text}`;
        }
      }
      return '';
    },
    ChangeQty(cardType, nominal, qty) {
      if (qty <= 0) {
        this.RemoveCard(cardType, nominal);
        return;
      }
      this.$store.dispatch('eps/ChangeQty', { cardType, nominal, qty });
    },
    RemoveCard(cardType, nominal) {
      this.$store.dispatch('eps/RemoveCard', { cardType, nominal });
    },
    SendForm() {
      this.epsSettings ? this.SendSms() : this.SendOrder();
    },
    ResetCode() {
      this.hash = null;
      this.code = '';
      this.dialogCheckSms = false;
    },
    SendSms() {
      const app = this;
      app.$store.getters.axl.post('confirmations/api/api-confirm/get-sms', { profile_id: app.user.profile_id, module: 'eps' })
        .then((res) => {
          app.hash = res.data.hash;
          app.dialogCheckSms = true;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    CheckCode() {
      const app = this;
      app.$store.getters.axl.post('confirmations/api/api-confirm/check-sms', {
        profile_id: app.user.profile_id,
        module: 'eps',
        code: app.code,
        hash: app.hash,
      })
        .then((res) => {
          app.hash = res.data.hash;
          app.SendOrder();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    SendOrder() {
      const app = this;
      const formData = app.form;
      formData.profile_id = app.user.profile_id;
      formData.items = app.$store.getters['eps/cartItems'];
      formData.hash = app.hash;


      app.$store.getters.axl.post('catalog/api-v3/orders/create', formData)
        .then(async () => {
          app.dialogOrdered = true;
          await app.$store.dispatch('GetProfile', app.user.profile_id);
          await app.$store.dispatch('eps/GetOrders', app.user.profile_id);
          await app.$store.dispatch('eps/ClearCart');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => app.ResetCode());
    },
    GoToOrders() {
      this.$router.push('/orders');
    },
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.form.address_data = sug.data;
          document.getElementById('delivery-address').focus();
        }
      });
    },
  },
};
